import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Col,
  ListGroup,
  ListGroupItem,
  Row,
  Input,
  Spinner,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchHistory,
  selectHistory,
  // selectSummary,
  selectHistoryLoading,
  selectHistoryError
} from '../../rtk/slices/historySlice/historySlice';
import { apiKey } from '../../utils/config';
import { format, isWithinInterval, subDays, subMonths, subYears } from 'date-fns';
import { selectFilterType } from '../../rtk/slices/filterSlice/filterSlice';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../firebase';

const HistoryPositions = () => {
  const dispatch = useDispatch();
  // const historyPositions = useSelector(selectHistory);
  const [historyPositions, setHistoryPositions] = useState([]);
  // const summary = useSelector(selectSummary);
  const loading = useSelector(selectHistoryLoading);
  const error = useSelector(selectHistoryError);
  const filterType = useSelector(selectFilterType); // Get filter type from Redux
  const [filteredPositions, setFilteredPositions] = useState([]);

  // Custom date states
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const account = user ? user.account : null;

    const tradesRef = collection(db, 'trades_collection')
    const q = query(
      tradesRef,
      where('account', '==', account),
      where('status', '==', 'completed')
    )
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const trades = querySnapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
      setHistoryPositions(trades);
    });

 return () => unsubscribe();
    // if (account) {
    //   dispatch(fetchHistory({ api_key: apiKey, account }));
    // }
  }, []);


  console.log('historyPositions', historyPositions);


  useEffect(() => {
    const today = new Date();
    let startDate;

    switch (filterType) {
      case 'Today':
        startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        break;
      case 'Last week':
        startDate = subDays(today, 7);
        break;
      case 'Last month':
        startDate = subMonths(today, 1);
        break;
      case 'Last 3 months':
        startDate = subMonths(today, 3);
        break;
      case 'Last 6 months':
        startDate = subMonths(today, 6);
        break;
      case 'Last year':
        startDate = subYears(today, 1);
        break;
      case 'Custom':
        startDate = customStartDate ? new Date(customStartDate) : null;
        break;
      case 'All':
      default:
        startDate = null;
    }

    const newFilteredPositions = historyPositions.filter((position) => {
      const openTime = position.closedAt ? new Date(position.closedAt) : null;
      if (!openTime || isNaN(openTime.getTime())) return false;
      const isInCustomRange = (customStartDate && customEndDate) ?
        isWithinInterval(openTime, { start: new Date(customStartDate), end: new Date(customEndDate) }) :
        false;

      // Exclude positions where type is "BALANCE" and symbol is an empty string
      const excludeBalanceType = (position.type === "BALANCE" && position.symbol === "") || position.profit === 0;

      // Apply the filter based on the selected filter type
      return !excludeBalanceType && (
        filterType === 'All'
          ? true
          : (filterType === 'Custom'
            ? isInCustomRange
            : (startDate ? isWithinInterval(openTime, { start: startDate, end: today }) : true))
      );
    });

    setFilteredPositions(newFilteredPositions);
  }, [filterType, historyPositions, customStartDate, customEndDate]);


  // Calculations for summary of filtered positions
  const totalDeposit = historyPositions
    .filter(position => position.type === "DEAL_BALANCE" && position.symbol === "")
    .reduce((sum, position) => sum + position.profit, 0);



  const totalProfit = filteredPositions.reduce((sum, position) => sum + position.profit, 0);
  const totalSwap = filteredPositions.reduce((sum, position) => sum + position.swap, 0);
  const totalCommission = filteredPositions.reduce((sum, position) => sum + position.commssion, 0);
  const totalWithdrawal = 0; // Assuming withdrawal is part of summary
  const totalBalance = totalDeposit + totalProfit - totalSwap - totalCommission - totalWithdrawal;
  const summary = [
    totalProfit,
    totalSwap,
    totalCommission,
    totalWithdrawal,
    totalBalance
  ]

  return (
    <Row>
      <Col xs={12}>
        <Card className='bg-body' style={{ maxHeight: "67.5vh", overflowY: "scroll", marginBottom: "5px", marginTop: "5px", scrollbarWidth: 'none' }}>
          <CardBody className="p-0">
            {/* Custom Date Inputs */}
            {filterType === 'Custom' && (
              <div className="d-flex justify-content-between mt-2">
                <Input
                  type="date"
                  placeholder="Start Date"
                  value={customStartDate}
                  onChange={(e) => setCustomStartDate(e.target.value)}
                />
                <Input
                  type="date"
                  placeholder="End Date"
                  value={customEndDate}
                  onChange={(e) => setCustomEndDate(e.target.value)}
                />
              </div>
            )}

            <ListGroup>
              {
                loading ? (
                  <div className="text-center">
                    <Spinner size="sm" color="primary" /> Loading...
                  </div>
                )

                  :
                  error ? (
                    // Render error row if there's an error

                    <p colSpan="11" className="text-center text-danger">
                      {" Page you are looking for doesn't exit or an other error ocurred or temporarily unavailable."}
                      {" Please try again."}
                    </p>

                  )
                    :
                    historyPositions && historyPositions.length > 0 ? (
                      historyPositions.map((position, index) => {
                        const orderType =
                          position.type === "DEAL_BUY" ? "BUY" :
                            position.type === "DEAL_SELL" ? "SELL" :
                              position.type === "DEAL_BALANCE" ? "Balance" :
                                "";


                        return (
                          <ListGroupItem key={`${position.id}-${index}`} className="px-1 py-1 bg-transparent" style={{ cursor: 'pointer' }}>
                            <div className="d-flex align-items-center">
                              <div className="flex-grow-1">
                                <div className="d-flex">
                                  <div className="flex-shrink-0">
                                    <h6 className="mb-0 fw-bold" style={{ fontSize: '16px' }}>
                                      {position.symbol}
                                      <span className="ms-1">
                                        <small className={` ${orderType === 'SELL' ? 'text-primary' : 'text-secondary'} fw-bold`}
                                          style={{ fontSize: '16x' }}
                                        >{orderType.toLowerCase()}</small>
                                      </span>
                                      <span className="ms-1">
                                        <small style={{ fontSize: '16px' }}
                                          className={` ${orderType === 'SELL' ? 'text-primary' : 'text-secondary'} fw-bold`}>{position.volume}</small>
                                      </span>
                                    </h6>
                                    <small className="text-muted" style={{ fontSize: '14px' }}>
                                      <span>{position.price}</span> &#8594; <span>{position.currentPrice}</span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div className="flex-shrink-0">
                                <div className="text-end">
                                  <small style={{ color: position.profit < 0 ? "#DC3A48" : "#3577f1", fontWeight: 700, fontSize: '16px' }}>{Number(position.profit).toFixed(2)}</small>
                                  <p className='text-muted mb-0' style={{ fontSize: '10px' }}>{position.open_time_formated}</p>
                                </div>
                              </div>
                            </div>
                          </ListGroupItem>
                        )
                      })
                    ) : (
                      <ListGroupItem>No history available.</ListGroupItem>
                    )}
            </ListGroup>
          </CardBody>
        </Card>

        <Card className='m-0 border-top bg-body'>
          <CardBody className='px-0 py-3 '>
            {/* Display Summary */}
            <ListGroup>
              <ListGroupItem style={{ fontSize: "16px", paddingInline: '5px' }} className="m-0 fw-bold py-0 border-0 bg-transparent">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="flex-shrink-0">
                        <h6 style={{ fontSize: "16px" }} className="fw-bold mb-0">Total Deposit:</h6>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <span style={{ fontWeight: 600 }}>{totalDeposit.toFixed(2)}</span>
                  </div>
                </div>
              </ListGroupItem>

              <ListGroupItem style={{ fontSize: "16px", paddingInline: '5px' }} className="m-0 fw-bold py-0 border-0 bg-transparent">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="flex-shrink-0 ">
                        <h6 style={{ fontSize: "16px" }} className="fw-bold mb-0">Total Profit:</h6>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <span style={{ fontWeight: 600 }}>{totalProfit.toFixed(2)}</span>
                  </div>
                </div>
              </ListGroupItem>

              <ListGroupItem style={{ fontSize: "16px", paddingInline: '5px' }} className="m-0 fw-bold py-0 border-0 bg-transparent">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="flex-shrink-0 ">
                        <h6 style={{ fontSize: "16px" }} className="fw-bold mb-0">Total Swap:</h6>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <span style={{ fontWeight: 600 }}>{totalSwap.toFixed(2)}</span>
                  </div>
                </div>
              </ListGroupItem>

              <ListGroupItem style={{ fontSize: "16px", paddingInline: '5px' }} className="m-0 fw-bold py-0 border-0 bg-transparent">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="flex-shrink-0 ">
                        <h6 style={{ fontSize: "16px" }} className="fw-bold mb-0">Total Commission:</h6>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <span style={{ fontWeight: 600 }}>{totalCommission.toFixed(2)}</span>
                  </div>
                </div>
              </ListGroupItem>

              <ListGroupItem style={{ fontSize: "16px", paddingInline: '5px' }} className="m-0 fw-bold py-0 border-0 bg-transparent">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="flex-shrink-0 ">
                        <h6 style={{ fontSize: "16px" }} className="fw-bold mb-0">Total Balance:</h6>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <span style={{ fontWeight: 600 }}>{totalBalance.toFixed(2)}</span>
                  </div>
                </div>
              </ListGroupItem>
            </ListGroup>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default HistoryPositions;
